import { atom } from 'nanostores';

export const CAMERA_ANGLE_MIN = 0;
export const CAMERA_ANGLE_MAX = 90;
export const CAMERA_ANGLE_STEP = 0.5;
export const DEFAULT_CAMERA_ANGLE = 22.5;

export const $cameraAngleToOrigin = atom<number>(DEFAULT_CAMERA_ANGLE);

export function setCameraAngleToOrigin(angle: number) {
  const clamped = Math.min(CAMERA_ANGLE_MAX, Math.max(CAMERA_ANGLE_MIN, angle));
  $cameraAngleToOrigin.set(clamped);
}

export const LEVEL_NAME_DEFAULT = 'New Level';
export const LEVEL_NUMBER_DEFAULT = 1;
export const LEVEL_PACK_NUMBER_DEFAULT = 1;
export const LEVEL_THEME_DEFAULT = 0;
export const LEVEL_PATTERN_DEFAULT = 0;

export const $levelName = atom<string>(LEVEL_NAME_DEFAULT);
export const $levelNumber = atom<number>(LEVEL_NUMBER_DEFAULT);
export const $levelPackNumber = atom<number>(LEVEL_PACK_NUMBER_DEFAULT);
export const $levelTheme = atom<number>(LEVEL_THEME_DEFAULT);
export const $levelPattern = atom<number>(LEVEL_PATTERN_DEFAULT);
